<template>
	<section id="intro" class="main-content intro">
		<div class="row align-center">
			<slot name="content">
				<div class="columns column12">
					<h1>
						<span class="bold">{{ title }}</span> {{ subtitle }}
					</h1>
					<div v-parse-links v-html="content" />
				</div>
			</slot>
		</div>
	</section>
	<slot />
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.row {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: center;
	max-width: 1280px;

	.column12 {
		max-width: 880px;
		margin: 0 auto;
	}
}
</style>
